import { Button } from "@std/@/shadcn/components/ui/button";
import Link from "next/link";

export const LinkButton = ({ href, children }) => {
    return (
        <Link href={href} className="flex flex-row gap-x-2 text-xs leading-tight px-4 py-2 items-center bg-cyan-200 hover:bg-cyan-300 active:shadow-lg transition duration-150 ease-in-out uppercase text-sp text-black rounded-full">
            {children}
        </Link>
    );
};